module.exports = __webpack_public_path__ + "dab774d0da4fe4c878782842d379aa91.svg";